/* MMW configurator UI polish (isolated, cosmetic only):
   0) Baseboard option, 1) context under the 4 result cards, 2) DIY card -> /pages/diy,
   3) accessories trimmed to LED + metal shelves, 4) simplified header,
   5) top bar stays visible, 6) on mobile caption + a compact render button share one row,
   7) move the mode selector cards to BELOW the builder grid. */
(function(){
  function $(id){ return document.getElementById(id); }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    var st=document.createElement('style');
    st.textContent='.wc-r-h{display:block;margin-top:6px;font-size:.74rem;color:var(--muted);line-height:1.3;font-weight:500}'+
      '.wc-acc{grid-template-columns:repeat(2,1fr)!important}'+
      '@media(max-width:820px){.wc-acc{grid-template-columns:1fr!important}'+
        '.wc-caprow{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;margin-top:8px}'+
        '.wc-caprow .wc-cap{margin:0!important;text-align:left;flex:1;font-size:.82rem!important;line-height:1.2}'+
        '.wc-caprow .wc-renderbar{margin:0!important;flex:none}'+
        '.wc-caprow .wc-render-btn{font-size:.82rem!important;padding:9px 16px!important;white-space:nowrap}'+
      '}';
    document.head.appendChild(st);

    var eb=document.querySelector('.wc .lp-eyebrow'); if(eb) eb.style.display='none';
    var h1=document.querySelector('.wc .wc-h1'); if(h1) h1.textContent='Design your wall.';
    var sub=document.querySelector('.wc .wc-sub'); if(sub){ sub.textContent='With our acoustic wood slat panels.'; sub.style.marginBottom='26px'; }

    var fin=$('wcFinish'), finField=(fin&&fin.closest)?fin.closest('.wc-field'):null;
    if(finField && !document.getElementById('wcBaseboard')){
      var bb=document.createElement('div'); bb.className='wc-field';
      bb.innerHTML='<span class="wc-lab">Baseboard</span>'+
        '<div class="wc-items">'+
          '<label class="wc-chip"><input type="radio" id="wcBaseboard" name="wcBaseboard" value="keep" checked> <span>Keep baseboard</span></label>'+
          '<label class="wc-chip"><input type="radio" name="wcBaseboard" value="remove"> <span>Remove &mdash; slats to the floor</span></label>'+
        '</div>'+
        '<small class="wc-hint">Removing the baseboard is possible depending on the job &mdash; we&rsquo;ll confirm on site.</small>';
      finField.parentNode.insertBefore(bb, finField.nextSibling);
    }

    var hints={ wcPanels:'24″ × 9 ft panels needed for your wall',
                wcFname:'The finish you selected',
                wcCover:'Wall area these panels cover',
                wcPrice:'Total for the option selected above' };
    Object.keys(hints).forEach(function(id){
      var b=$(id); if(!b||!b.closest) return; var cell=b.closest('.wc-r'); if(!cell||cell.querySelector('.wc-r-h')) return;
      var s=document.createElement('small'); s.className='wc-r-h'; s.textContent=hints[id]; cell.appendChild(s);
    });

    var ways=document.querySelectorAll('.wc-ways .wc-way');
    if(ways[0]){ ways[0].setAttribute('href','/pages/diy'); var l=ways[0].querySelector('.wc-way-l'); if(l) l.textContent='See the DIY guide ›'; }

    var acc=document.querySelector('.wc-acc');
    if(acc){
      var cards=acc.querySelectorAll('.wc-acard');
      for(var i=cards.length-1;i>=2;i--){ if(cards[i]&&cards[i].parentNode) cards[i].parentNode.removeChild(cards[i]); }
      if(cards[0]){ var k=cards[0].querySelector('.wc-way-k'); if(k) k.textContent='LED lighting';
        var h=cards[0].querySelector('h3'); if(h) h.textContent='Warm LED, tucked into the slats.';
        var ll=cards[0].querySelector('.wc-way-l'); if(ll) ll.textContent='Shop LED ›'; }
      if(cards[1]){ var h2=cards[1].querySelector('h3'); if(h2) h2.textContent='Metal shelves that float on the slats.'; }
    }

    /* Top bar stays visible (no hide-on-scroll). */
    var bar=document.querySelector('.lp-bar'); if(bar){ bar.style.transform='none'; }

    /* Cards under the builder: move the mode selector below the configurator grid. */
    var wcMode=document.querySelector('.wc-mode'), wcGrid=document.querySelector('.wc-grid');
    if(wcMode && wcGrid && wcGrid.parentNode){ wcGrid.parentNode.insertBefore(wcMode, wcGrid.nextSibling); wcMode.classList.add('wc-mode--below'); }

    /* Mobile: caption + a compact render button on one row inside the sticky card. */
    if(window.matchMedia && window.matchMedia('(max-width:820px)').matches){
      var cap=$('wcCap');
      var rbar=document.querySelector('.wc-preview .wc-renderbar');
      var rbtn=$('wcRender');
      if(cap && rbar && cap.parentNode){
        var row=document.createElement('div'); row.className='wc-caprow';
        cap.parentNode.insertBefore(row, cap);
        row.appendChild(cap);
        row.appendChild(rbar);
        if(rbtn){ rbtn.innerHTML='&#10022; Render'; }
      }
    }
  });
})();
